import Email from "@mapmycustomers/shared/types/email/Email";

import isEmailDeliveryFailed from "./isEmailDeliveryFailed";

type DeliverableEmail = Pick<Email, "hasBounced" | "linksOpened" | "opened" | "status">;

// Could this recipient have engaged? A bounce says no even when the row records engagement,
// because the delivery-failure notice is read as a reply and stamps `opened`. The other
// failures yield to recorded engagement, so this is not `!isEmailDeliveryFailed`.
const isEmailDelivered = (email: DeliverableEmail): boolean =>
  !email.hasBounced &&
  (!!email.opened || (email.linksOpened?.length ?? 0) > 0 || !isEmailDeliveryFailed(email));

export default isEmailDelivered;
